import { render, staticRenderFns } from "./RsaAccettazioneListComponent.vue?vue&type=template&id=ebb62822"
import script from "./RsaAccettazioneListComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports